<template>
  <Card>
    <AbsenceForm />
  </Card>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AbsenceForm from '../forms/AbsenceForm.vue';
import Card from './_shared/Card.vue';

export default defineComponent({
  components: {
    Card,
    AbsenceForm,
  },
});
</script>
